/* tslint:disable */

/**
 */
export class RpVehicleAllForm {
    from_date?: string;
    to_date?: string;
    type?: number;
}
